import * as React from "react";
import { parseTagSanitizeAndWhitelist } from "../../../helpers/Utils";

export const CheckBox = ({ name, value, label, disabled, checked, onChange }) => (
	<label className="checkset-inline">
		<input
			readOnly
			type="checkbox"
			className="checkset__checkbox"
			disabled={disabled}
			name={name}
			value={value}
			checked={checked}
			onChange={onChange}
		/>
		{label && <span>{parseTagSanitizeAndWhitelist(label)}</span>}
	</label>
);
